<ion-img
  [src]="iconUrl$ | async"
  [ngClass]="iconClass$ | async"
  [attr.data-test]="dataTestKey"
  matTooltip="{{ tooltipTranslationString | translate }}"
  matTooltipPosition="right"
  (click)="onClick($event)"
></ion-img>
